import { IRouteResolver } from '../types';
import { ResolverType } from '../resolver-types.enum';

export interface DashboardTransactionInstructionsRouteParams {
    transactionId: string;
}

export class DashboardTransactionInstructionsRouteResolver implements IRouteResolver {
    public pattern: RegExp = /^\/my\/dashboard\/transactions\/v3\/(\d+)\/instructions$/;
    public type: ResolverType = ResolverType.DASHBOARD_TRANSACTION_INSTRUCTIONS;

    public resolve(match: RegExpMatchArray): DashboardTransactionInstructionsRouteParams {
        return {
            transactionId: match[1]
        };
    }
}
